export default "__VITE_ASSET__DBE1aEXQ__"